import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Custom report filter view class extending JetView
 */
export default class FilterCustomReportView extends JetView {
    /**
     * Configures the view layout and components
     * @returns {Object} The configuration object for the view
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 10,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for Id
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Id'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Id'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for Name
                            name: 'Name',
                            minWidth: 200,
                            label: _('Nombre'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder text
                        },
                        {
                            view: 'combo', // Dropdown for Type
                            name: 'Type',
                            minWidth: 200,
                            id: 'Type',
                            label: _('Tipo'), // Label in Spanish
                            labelPosition: 'top',
                            options: [], // Options to be populated later
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'combo', // Dropdown for State
                            name: 'State',
                            minWidth: 200,
                            label: _('Estado'), // Label in Spanish
                            labelPosition: 'top',
                            options: [
                                { id: 'G', value: _('Generado') }, // Option for Generated
                                { id: 'P', value: _('Pendiente') }, // Option for Pending
                            ],
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to request report
                    value: _('Solicitar Reporte'), // Button label
                    type: 'form',
                    width: screen == 'small' ? 150 : 200, // Responsive width
                    height: screen == 'small' ? 50 : 0, // Responsive height
                    click: () => {
                        this.app.callEvent('addCustomReport:button', [{}]); // Event call on click
                    },
                },
                {
                    view: 'button', // Button to clear form
                    value: _('Limpiar'), // Button label
                    width: screen == 'small' ? 0 : 100, // Responsive width
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Clear form values
                    },
                },
                {
                    id: 'consultDesk',
                    view: 'button', // Button to consult
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    width: screen == 'small' ? 0 : 100, // Responsive width
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('customReport:filter', [filterdata]); // Event call with filter data
                        $$('b1').collapse(); // Collapse accordion
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to request report in popup
                            value: _('Solicitar Reporte'), // Button label
                            type: 'form',
                            click: () => {
                                this.app.callEvent('addCustomReport:button', [{}]); // Event call on click
                            },
                        },
                    ],
                },
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to clear form in popup
                            value: _('Limpiar'), // Button label
                            click: () => {
                                $$('myForm2').setValues(
                                    $$('myForm2').getCleanValues(), // Clear form values
                                );
                            },
                        },
                        {
                            view: 'button', // Button to consult in popup
                            value: _('Consultar'), // Button label
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get form values
                                this.app.callEvent('customReport:filter', [
                                    filterdata, // Event call with filter data
                                ]);
                                $$('filterPopup').hide(); // Hide popup
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Form ID for the popup
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm', // Main form ID
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder if not
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }
}

// FILE DOCUMENTED
